import * as React from 'react';
import {useSelector} from 'react-redux';
import {selectCsrfTokenError} from 'src/selectors/authentication';
import {InContextAlert} from '@spaced-out/ui-design-system/lib/components/InContextAlert';
import maincss from './main.css';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import logger from 'src/utils/logger';


export const CsrfError = () => {
  const csrfTokenError = useSelector(selectCsrfTokenError);
  const {t} = useLabelTranslation();

  const handleTryAgain = () => {
    try {
      window.location.reload();
    } catch (error) {
      logger.error('Error reloading page', error);
    }
  };

  if (!csrfTokenError) {
    return null;
  }
  return (
    <InContextAlert
      semantic="danger"
      classNames={{wrapper: maincss.apiError}}
      actionText={t('Try_again', 'Try again')}
      onAction={handleTryAgain}
    >
      {t(
        'Something_went_wrong_while_signing_you_in',
        'Something went wrong while signing you in.',
      )}
    </InContextAlert>
  );
};
